import { getAppState } from "../state";
import { i18n } from "./i18nService";
import { handlePartOfText } from "./layoutService";
import { getAddOnByName } from "../utils/subscriptionUtils";

const starzplaysports = "starzplaysports";
const starzplay = "starzplay";

export default function getSportsAddons(type, category) {
  let allAddons =
    getAppState().subscriptions?.filter(
      data => !data?.configuration?.isMainPackage && !data?.configuration.isCustomAddon
    ) || [];
  let allSportsAddons = getAllSportsAddons(allAddons);
  let allActiveAddons = getActiveSportsAddons(allSportsAddons);
  let allInactiveAddons = getInactiveSportsAddons(allSportsAddons, allActiveAddons);

  if (type === "ACTIVE") {
    return (
      (getAppState().userLogged &&
        getAppState().addons.length > 0 &&
        category === "ListBrandsActive" &&
        processGridFeeds([...allActiveAddons], category)) ||
      []
    );
  } else if (type === "IN_ACTIVE") {
    return (
      (getAppState().userLogged &&
        getAppState().addons.length > 0 &&
        category === "ListBrandsDisabled" &&
        processGridFeeds([...allInactiveAddons], category)) ||
      processGridFeeds([...allInactiveAddons], category)
    );
  }
  return [];
}

function getAllSportsAddons(allAddons) {
  return allAddons.filter(dataAllAddons => dataAllAddons?.configuration?.isSports === true);
}

function getInactiveSportsAddons(allSportsAddons, allActiveAddons) {
  return allSportsAddons.filter(dataActiveAddons => allActiveAddons.indexOf(dataActiveAddons) === -1);
}

function getActiveSportsAddons(allSportsAddons) {
  return allSportsAddons.filter(dataAllAddons =>
    getAppState().addons.find(
      dataActiveAddons => dataAllAddons.name === dataActiveAddons.name && dataActiveAddons.status === "Active"
    )
  );
}

function processGridFeeds(feeds, category) {
  return feeds.map(feed => {
    // FIXME Shouldn't this be done in SDK or Middleware?
    if (category === "ListBrandsDisabled") {
      feed["icon"] = "lock";
      feed["imageUrl"] = feed?.configuration?.logoDefaultPNG
        ? feed?.configuration?.logoDefaultPNG
        : feed?.configuration?.logoDefaultPNG;
      feed["posterUrl"] = feed?.configuration?.backgroundImagePNG
        ? feed?.configuration?.backgroundImagePNG
        : feed?.configuration?.backgroundImageJPG;
      feed["title"] = feed.name;
      feed["infoText"] =
        feed?.configuration?.isStandalone === false
          ? handlePartOfText(feed)
          : !feed?.configuration?.isStandalone
          ? feed?.configuration?.isSports && feed?.configuration?.isIncludedInSportsPackage
            ? i18n.get("pages.brands.partOf", getSpSportsPackageDisplayName())
            : feed?.isBrand
            ? i18n.get("pages.brands.partOf", getStarzplayPackageDisplayName())
            : null
          : null;
    } else {
      feed["icon"] = null;
      feed["infoText"] = null;
      feed["imageUrl"] = feed?.configuration?.logoDefaultPNG
        ? feed?.configuration?.logoDefaultPNG
        : feed?.configuration?.logoDefaultPNG;
      feed["posterUrl"] = feed?.configuration?.backgroundImagePNG
        ? feed?.configuration?.backgroundImagePNG
        : feed?.configuration?.backgroundImageJPG;
      feed["title"] = feed.name;
    }
    return feed;
  });
}

export function getStarzplayPackageDisplayName() {
  return getPackageDisplayName(starzplay);
}
export function getSpSportsPackageDisplayName() {
  return getPackageDisplayName(starzplaysports);
}

export function getPackageDisplayName(packageName) {
  let pkgName =
    getAppState().subscriptions?.find(data => data.name === packageName && data?.configuration?.isMainPackage) || [];
  return pkgName?.displayName;
}

export function isSpSportsAddonContent(addOnName) {
  let spSportsPackage =
    getAppState().subscriptions?.find(data => data?.configuration?.isMainPackage && data?.configuration?.isSports) ||
    [];
  let allSportsAddonsIncludedInSpSports = spSportsPackage?.configuration?.subscriptionIncludes?.split(",");
  const currentAddOn = getAddOnByName(addOnName);
  if (
    allSportsAddonsIncludedInSpSports?.indexOf(addOnName) !== -1 ||
    (currentAddOn?.configuration?.isMainPackage && currentAddOn?.configuration?.isSports)
  ) {
    return true;
  }
  return false;
}
